const SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" viewBox="0 0 192 192">
  <defs>
    <path id="b" d="M-7 -6h14v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2ZM-3.5 -6v-3a3.5 3.5 0 0 1 7 0v3"/>
    <path id="t" d="M-10 -6h10l10 6l-10 6h-10ZM-6 -1.5a1.5 1.5 0 0 0 0 3a1.5 1.5 0 0 0 0 -3"/>
    <path id="x" d="M0 -12L9 -7v10L0 8L-9 3v-10ZM-9 -7l9 5l9 -5M0 -2v10"/>
    <path id="r" d="M-11 -9h3l2.6 13h11l2.6 -9H-7.2M-3.8 5.9a1.6 1.6 0 0 0 0 3.2a1.6 1.6 0 0 0 0 -3.2M3.8 5.9a1.6 1.6 0 0 0 0 3.2a1.6 1.6 0 0 0 0 -3.2"/>
    <path id="d" d="M-8 -6v12M-5 -6v12M-2 -6v9M1 -6v12M4 -6v9M7 -6v12"/>
    <path id="m" d="M-9 -11h18M-9 -11l-2 5M9 -11l2 5M-11 -6a2.75 2.75 0 0 0 5.5 0a2.75 2.75 0 0 0 5.5 0a2.75 2.75 0 0 0 5.5 0a2.75 2.75 0 0 0 5.5 0M-8 -3.2V9h16V-3.2M-2 9V3h4v6"/>
  </defs>
  <g fill="none" stroke="#1B2420" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" opacity="1">
    <use href="#b" transform="translate(24 24) rotate(-6)"/>
    <use href="#t" transform="translate(72 24) rotate(12)"/>
    <use href="#b" transform="translate(120 24) rotate(7)"/>
    <use href="#x" transform="translate(168 24) rotate(-8)"/>
    <use href="#r" transform="translate(24 72) rotate(6)"/>
    <use href="#b" transform="translate(72 72) rotate(4)"/>
    <use href="#d" transform="translate(120 72) rotate(-10)"/>
    <use href="#b" transform="translate(168 72) rotate(-7)"/>
    <use href="#b" transform="translate(24 120) rotate(6)"/>
    <use href="#x" transform="translate(72 120) rotate(9)"/>
    <use href="#b" transform="translate(120 120) rotate(-5)"/>
    <use href="#t" transform="translate(168 120) rotate(-12)"/>
    <use href="#m" transform="translate(24 168) rotate(8)"/>
    <use href="#b" transform="translate(72 168) rotate(-8)"/>
    <use href="#r" transform="translate(120 168) rotate(-6)"/>
    <use href="#b" transform="translate(168 168) rotate(7)"/>
  </g>
</svg>`

export const ECOMMERCE_BOT_PATTERN_DATAURI = `data:image/svg+xml,${encodeURIComponent(SVG)}`
export const ECOMMERCE_BOT_PATTERN_OPACITY = 0.07
